import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import less from "less";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./style/index.less";
import "./assets/icon/iconfont.css";
import "amfe-flexible/index.js";
import './utils/rem'
Vue.config.productionTip = false;

Vue.use(less);
Vue.use(ElementUI);

// 监听路由跳转返回页面顶部
router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  window.pageYOffset = 0;
  next();
});
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount("#app");
